module.exports = __webpack_public_path__ + "img/ASO_fr19.bfa29232.png";